
//获取屏幕类型

export const SCREENTYPE=(()=>{
    const screenWidth=window.screen.width;
    const screenHeight=window.screen.height;
    let type='LEFT'
    if(screenWidth/screenHeight>1.3){
        type='LEFT'
    }else{
        type='TOP'
    }
    return type
})()